import { ajax } from "@/assets/js/ajax";

export function getCarInfo(data) {
  //车辆信息
  return ajax({
    url: "carInfo",
    type: "get",
    data: data,
  });
}

export function getCarList(data) {
  //车辆列表
  return ajax({
    url: "debtorCar/index",
    type: "get",
    data: data,
  });
}

export function AddCar(data) {
  //车辆添加
  return ajax({
    url: "debtorCar/add",
    type: "post",
    data: data,
    contentType: "application/json",
  });
}

export function EditCar(data) {
  //车辆修改
  return ajax({
    url: "debtorCar/edit",
    type: "post",
    data: data,
    contentType: "application/json",
  });
}

export function DelCar(data) {
  //车辆删除
  return ajax({
    url: "debtorCar/del",
    type: "get",
    data: data,
  });
}
